import React from 'react';
import type { CSSProperties } from 'react';

type Props = {
  name: string | null | undefined;
  className?: string;
  style?: CSSProperties;
  maxLen?: number;
};

export default function WorkplaceNameDisplay({ name, className, style, maxLen }: Props) {
  const full = String(name ?? '').trim() || '';
  let displayText = full || '—';
  if (maxLen != null && displayText !== '—' && displayText.length > maxLen) {
    displayText = `${displayText.slice(0, maxLen)}…`;
  }

  const titleAttr = (maxLen != null && full.length > maxLen) ? full : undefined;

  return (
    <span
      className={className}
      style={style}
      title={titleAttr}
    >
      {displayText}
    </span>
  );
}
